import url_ from "asset-data:assets/galleries/featured/tunnel3_e4f6922572__1600.jpg";
export const url = url_;